import { Price, Text } from '@kanda-libs/ks-design-library';
import FinanceOptions from 'components/FinanceOptions';
import InfoCard from 'components/InfoCard';
// import OpenBankingInfo from 'components/OpenBankingInfo';
import OpenBankingInfo from 'components/OpenBankingInfo';
import JobFinanceBankingSubsidy from './JobFinanceBankingSubsidy';
import JobFinanceDepositChosen from './JobFinanceDepositChosen';
import JobFinanceFinanceSubsidy from './JobFinanceFinanceSubsidy';
import useJobFinanceOptions from './useJobFinanceOptions';

const JobFinanceOptions: React.FunctionComponent = function ({}) {
  const {
    type,
    isLoading,
    classNames,
    deposit,
    total,
    loan,
    subsidy,
    payout,
    onAcknowledgeClick,
    showFinancePayout,
    showBankingPayout,
    acknowledged,
    job,
    paidByOB,
    isCashDeposit,
    showOpenBanking,
    ...rest
  } = useJobFinanceOptions();
  return (
    <div className={classNames.card}>
      <InfoCard
        title={type === 'all' ? 'Payment Options' : 'Chosen Option'}
        isLoading={isLoading}
      >
        <div className="flex flex-col gap-y-4 order-2">
          {((type === 'all' && showOpenBanking) || paidByOB) && (
            <>
              <Text
                className="text-16-20-em text-neutral-800"
                text="Open Banking"
                isLoading={isLoading}
              />
              <OpenBankingInfo job={job} isLoading={isLoading} />
              <div className="w-full border-b border-neutral-300" />
            </>
          )}
          {(type === 'all' || (type === 'selected' && !paidByOB)) && (
            <>
              <Text
                className="text-16-20-em text-neutral-800"
                text="Finance Options"
                isLoading={isLoading}
              />
              <FinanceOptions
                {...rest}
                total={total}
                deposit={deposit}
                showHandle={false}
                hideBox
                hideNoRates
                hideSubtitle
                hideUnavailable
                ignoreConfigs
                isLoading={isLoading}
              />
            </>
          )}
        </div>
        <div className={classNames.deposit}>
          {type === 'selected' && (
            <JobFinanceDepositChosen
              acknowledged={acknowledged}
              onAcknowledgeClick={onAcknowledgeClick}
            />
          )}
        </div>

        <div className="grid grid-cols-[min-content_auto] order-5 text-14-22-em gap-x-2 text-neutral-700">
          <Text
            className="my-auto whitespace-nowrap"
            text="Job Total:"
            isLoading={isLoading}
          />
          <Price
            amount={total}
            color="neutral-800"
            poundsClassName="text-16-20-em"
            centsClassName="text-16-20-em"
            className="ml-auto"
            isLoading={isLoading}
          />
          {isCashDeposit && (
            <>
              <Text className="my-auto" text="Deposit:" isLoading={isLoading} />
              <div className="flex flex-row justify-end my-auto">
                <p className="text-neutral-800 my-auto">-</p>
                <Price
                  amount={deposit}
                  color="neutral-800"
                  poundsClassName="text-16-20-em"
                  centsClassName="text-16-20-em"
                  className="ml-auto"
                  isLoading={isLoading}
                />
              </div>
            </>
          )}
          {!isLoading && showFinancePayout && <JobFinanceFinanceSubsidy />}
          {!isLoading && showBankingPayout && <JobFinanceBankingSubsidy />}
        </div>
      </InfoCard>
    </div>
  );
};

export default JobFinanceOptions;
